import { useEffect, useState } from 'react';
import {
    Autocomplete,
    Box, Button, IconButton, Stack,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    TextField, Tooltip, Typography
} from '@mui/material';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import Loader from '../../../../Components/Loader';
import { CommonPatientDetails } from '../../../../Components/Common Components/CommonComponents';
import { Colors } from '../../../../Styles/Colors';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { getCachevalue } from '../../../../Utility/Services/CacheProviderService';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { IP_routeList } from '../../../../Utility/Constants';
import dayjs from 'dayjs';
import { localGetItem } from "../../../../Utility/Services/CacheProviderService";

export default function NewDocImmunization() {
    const [patientDetails, setPatientDetails] = useState({});
    const [immunizationData, setImmunizationData] = useState([]);
    const [selectedData, setSelectedData] = useState({
        age: '',
        vaccination: '',
        dose: '',
        brand: '',
        given_date: null,
        serviceName: '',
        serviceDoseNo: '',
        lotNo: '',
        manufacturerName: '',
        route: '',
        comments: '',
        id: null
    });
    const [openDatePicker, setOpenDatePicker] = useState(false);
    const [finalArray, setFinalArray] = useState([]);
    const [isErrorMsg, setIsErrorMsg] = useState(false);
    const [isErrorMsgText, setIsErrorMsgText] = useState('');
    const [successMsg, setSuccessMsg] = useState(false);
    const [successMsgText, setSuccessMsgText] = useState('');
    const [isLoader, setIsLoader] = useState(false);
    const [patientId, setPatientId] = useState(null);
    const [appointmentId, setAppointmentId] = useState(null);
    const [clinicId, setClinicId] = useState(null);

    useEffect(() => {
        const clinic = getCachevalue('SelectedDoctorClinic');
        const appointment = JSON.parse(getCachevalue('DoctorPatientData'));

        setClinicId(clinic);
        setAppointmentId(appointment?.appointment_id);
        setPatientId(appointment?.patient_id);
    }, []);

    useEffect(() => {
        if (patientId) {
            getPatientDetailData();
            getImmunizationData();
        }
    }, [patientId]);

    const getPatientDetailData = async () => {
        try {
            const res = await RestAPIService.getAll(
                Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + patientId
            );
            if (res?.data?.status === 'success') {
                setPatientDetails(res.data.data);
            }
        } catch (e) {
            errorMessage(e.message);
        }
    };

    const getImmunizationData = async () => {
        try {
            const res = await RestAPIService.GetWithoutReplica(Serviceurls.PD_IMMUNIZATION_CHART + '?patient_id=' + patientId);
            if (res?.data?.status === 'success') {
                setImmunizationData(res.data.data);

                const grouped = {};
                res.data.data.forEach(({ age, ...rest }) => {
                    if (!grouped[age]) {
                        grouped[age] = { age, data: [] };
                    }
                    grouped[age].data.push(rest);
                });

                setFinalArray(Object.values(grouped));
            }
        } catch (e) {
            errorMessage(e.message);
        }
    };

    const errorMessage = (msg) => {
        setIsErrorMsg(true);
        setIsErrorMsgText(msg);
    };

    const successMessage = (msg) => {
        setSuccessMsg(true);
        setSuccessMsgText(msg);
    };

    const msgClose = () => {
        setIsErrorMsg(false);
        setSuccessMsg(false);
    };

    const onClearValue = () => {
        setSelectedData({
            age: '',
            vaccination: '',
            dose: '',
            brand: '',
            given_date: null,
            serviceName: '',
            serviceDoseNo: '',
            lotNo: '',
            manufacturerName: '',
            route: '',
            comments: '',
            id: null,
        });
    };

    const onAddHandler = async (iscomplete = false) => {
        const hasAbha = localGetItem("has_abha_service") === 'true' ? true : false
        try {
            if (!selectedData.given_date) {
                errorMessage("Please select given date");
                return;
            } else if (hasAbha) {
                if (!selectedData?.vaccination) {
                    errorMessage("Please enter Vaccination");
                    return;
                } else if (!selectedData?.dose) {
                    errorMessage("Please enter Dose");
                    return;
                } else if (!selectedData?.serviceName) {
                    errorMessage("Please enter Service Name");
                    return;
                } else if (!selectedData?.serviceDoseNo) {
                    errorMessage("Please enter Service Dose No");
                    return;
                } else if (!selectedData?.lotNo) {
                    errorMessage("Please enter Lot No");
                    return;
                } else if (!selectedData?.manufacturerName) {
                    errorMessage("Please enter Manufacturer Name");
                    return;
                } else if (!selectedData?.route) {
                    errorMessage("Please select Route");
                    return;
                }
            }

            setIsLoader(true);
            try {
                const payload = {
                    brand_name: selectedData.brand,
                    given_date: selectedData.given_date
                        ? selectedData.given_date.format('DD-MM-YYYY')
                        : null,
                    series_name: selectedData.serviceName,
                    series_dose_no: selectedData.serviceDoseNo,
                    lot_no: selectedData.lotNo,
                    manufacturer_name: selectedData.manufacturerName,
                    route: selectedData.route?.value || null,
                    comments: selectedData.comments,
                    id: selectedData.id || null,
                    is_frozen: iscomplete,
                };

                const res = await RestAPIService.updateWithOutId(payload,
                    Serviceurls.PD_IMMUNIZATION_CHART
                );

                if (res?.data?.status === 'success') {
                    successMessage(res?.data?.message || "Immunization record added successfully");
                    onClearValue();
                    getImmunizationData();
                } else {
                    errorMessage(res?.data?.message || "Failed to add immunization record");
                }
            } catch (e) {
                errorMessage(e?.response?.data?.message);
            } finally {
                setIsLoader(false);
            }
        } catch (e) {
            errorMessage(e.message);
        }
    }

    const returnduedateBgColor = (data) => {
        switch (data) {
            case "Upcoming": return 'orange'
            case "Over Due": return 'red'
            case "Completed": return 'green'
            default: return "transparent"
        }
    }

    const fetchFreezeUnfreezeImmunization = async (data, item) => {
        try {
            const parsedDate = data.given_date
                ? dayjs(data.given_date, 'DD-MM-YYYY')
                : null;
            setSelectedData({
                age: item?.age || '',
                vaccination: data.vaccination || '',
                dose: data.dose || '',
                brand: data.brand_name || '',
                given_date: parsedDate,
                serviceName: data.series_name || '',
                serviceDoseNo: data.series_dose_no || '',
                lotNo: data.lot_no || '',
                manufacturerName: data.manufacturer_name || '',
                route: IP_routeList.find((item) => item?.value === data?.route) || '',
                comments: data.comments || '',
                id: data?.id || null
            });
        } catch (e) {
            errorMessage(e.message);
        }
    }

    const renderTbl = (List) => {
        try {
            return (
                <Box component={'div'} width={'70vw'} height={'67vh'} border={'1px solid lightgray'} backgroundColor={'white'}>
                    <Box>
                        <TableContainer sx={{ maxHeight: '65vh' }}>
                            <Table size='small' stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ backgroundColor: '#F5F8F7', fontWeight: 'bold', width: '15vw' }}>{"Age"}</TableCell>
                                        <TableCell sx={{ backgroundColor: '#F5F8F7', fontWeight: 'bold', width: '13vw' }}>{"Vaccination"}</TableCell>
                                        <TableCell sx={{ backgroundColor: '#F5F8F7', fontWeight: 'bold', width: '10vw' }}>{"Dose"}</TableCell>
                                        <TableCell sx={{ backgroundColor: '#F5F8F7', fontWeight: 'bold', width: '13vw' }}>{"Route"}</TableCell>
                                        <TableCell sx={{ backgroundColor: '#F5F8F7', fontWeight: 'bold', width: '15vw' }}>{"Due Date"}</TableCell>
                                        <TableCell sx={{ backgroundColor: '#F5F8F7', fontWeight: 'bold', width: '15vw' }}>{"Given Date"}</TableCell>
                                        <TableCell sx={{ backgroundColor: '#F5F8F7', fontWeight: 'bold', width: '13vw' }}>{"Brand"}</TableCell>
                                        <TableCell sx={{ backgroundColor: '#F5F8F7', fontWeight: 'bold', width: '5vw' }}>{"Action"}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {List.map((group, groupIndex) => (
                                        group.data.map((row, rowIndex) => (
                                            <TableRow key={rowIndex}>
                                                {rowIndex === 0 && (
                                                    <TableCell rowSpan={group.data.length} sx={{ width: '15vw', borderRight: '1px solid #ddd' }}>{group.age ? group.age : '-'}</TableCell>
                                                )}
                                                <TableCell sx={{ width: '13vw', verticalAlign: 'middle' }}>{row?.vaccination?.length > 15 ?
                                                    <Tooltip title={row?.vaccination} placement='top'><Typography sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} component={'div'} fontSize={"0.8rem"}>{(row.vaccination).slice(0, 15) + '...'}</Typography></Tooltip> :
                                                    row?.vaccination ? <Typography component={'div'} fontSize={"0.8rem"} sx={{ whiteSpace: 'nowrap' }}>{row?.vaccination}</Typography> : '-'}
                                                </TableCell>
                                                <TableCell sx={{ width: '13vw' }}>{row?.dose?.length > 20 ?
                                                    <Tooltip title={row?.dose} placement='top'><Typography sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} component={'div'} fontSize={"0.8rem"}>{(row.dose).slice(0, 20) + '...'}</Typography></Tooltip> :
                                                    row?.dose ? <Typography component={'div'} fontSize={"0.8rem"} sx={{ whiteSpace: 'nowrap' }}>{row?.dose}</Typography> : '-'}
                                                </TableCell>
                                                <TableCell sx={{ width: '13vw' }}>{row?.route?.length > 25 ?
                                                    <Tooltip title={row?.route} placement='top'><Typography sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} component={'div'} fontSize={"0.8rem"}>{(row.route).slice(0, 25) + '...'}</Typography></Tooltip> :
                                                    row?.route ? <Typography component={'div'} fontSize={"0.8rem"} sx={{ whiteSpace: 'nowrap' }}>{row?.route}</Typography> : '-'}
                                                </TableCell>
                                                <TableCell sx={{ width: '15vw', backgroundColor: returnduedateBgColor(row?.color) }}>{row.due_date ? row.due_date : '-'}</TableCell>
                                                <TableCell sx={{ width: '15vw' }}>{row.given_date ? row.given_date : '-'}</TableCell>
                                                <TableCell sx={{ width: '10vw', verticalAlign: 'middle' }}>{row?.brand_name?.length > 15 ?
                                                    <Tooltip title={row?.brand_name} placement='top'><Typography sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} component={'div'} fontSize={"0.8rem"}>{(row.brand_name).slice(0, 15) + '...'}</Typography></Tooltip> :
                                                    row?.brand_name ? <Typography component={'div'} fontSize={"0.8rem"} sx={{ whiteSpace: 'nowrap' }}>{row?.brand_name}</Typography> : '-'}
                                                </TableCell>
                                                <TableCell sx={{ width: '5vw', display: 'flex', justifyContent: "center" }}>
                                                    <Tooltip arrow title={row.is_frozen ? 'Lock' : 'Edit'} placement='top'>
                                                        <IconButton disabled={row.is_frozen} onClick={() => fetchFreezeUnfreezeImmunization(row, group)}>
                                                            <img style={{ width: '1.4vw', height: '1.4vw' }} src={row.is_frozen ? ImagePaths.LockDisable.default : ImagePaths.LabEditButton.default} alt='lock' />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Box>
            )
        } catch (e) {
            errorMessage(e.message)
        }
    };

    const renderRightSide = () => {
        const dobDate = patientDetails?.dob ? dayjs(patientDetails.dob, 'YYYY-MM-DD') : null;
        const hasAbha = localGetItem("has_abha_service") === 'true' ? true : false

        try {
            return (
                <Box component={'div'} ml="0.5vw" width={'22vw'} height={'67vh'} border={'1px solid lightgray'} backgroundColor={'white'}>
                    <Box sx={{ borderBottom: '1px solid #CACACA' }}>
                        <Typography fontWeight={'bold'} sx={{ backgroundColor: "#FAF9F9" }} fontSize={'1rem'} mb="0.5vw" p={'0.5vw'}>{"Immunization Chart"}</Typography>
                        <Box display="flex" flexDirection="row" flexWrap="nowrap" sx={{ width: "100%", padding: '0.5vw' }}>
                            <Box sx={{ width: '25%' }}>
                                <Typography fontWeight={'bold'} color="black" fontSize={'0.9rem'}>{"Age"}</Typography>
                                <Typography fontSize={'0.85rem'}>
                                    {selectedData?.age?.length > 10 ? (
                                        <Tooltip title={selectedData?.age} placement='top'>
                                            <Typography fontSize={'0.8rem'}>{selectedData?.age.slice(0, 10)}...</Typography>
                                        </Tooltip>) : (selectedData?.age || '-')}
                                </Typography>
                            </Box>
                            <Box sx={{ width: '50%' }}>
                                <Typography fontWeight={'bold'} color="black" fontSize={'0.9rem'}>{`Vaccination${hasAbha ? " *" : ""}`}</Typography>
                                <Typography fontSize={'0.85rem'}>
                                    {selectedData?.vaccination?.length > 20 ? (
                                        <Tooltip title={selectedData?.vaccination} placement='top'>
                                            <Typography fontSize={'0.8rem'}>{selectedData?.vaccination.slice(0, 20)}...</Typography>
                                        </Tooltip>) : (selectedData?.vaccination || '-')}
                                </Typography>
                            </Box>
                            <Box sx={{ width: '25%' }}>
                                <Typography fontWeight={'bold'} color="black" fontSize={'0.9rem'}>{`Dose${hasAbha ? " *" : ""}`}</Typography>
                                <Typography fontSize={'0.85rem'}>
                                    {selectedData?.dose?.length > 10 ? (
                                        <Tooltip title={selectedData?.dose} placement='top'>
                                            <Typography fontSize={'0.8rem'}>{selectedData?.dose.slice(0, 10)}...</Typography>
                                        </Tooltip>) : (selectedData?.dose || '-')}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box>
                        <Typography fontWeight={'bold'} sx={{ backgroundColor: "#FAF9F9" }} fontSize={'1rem'} p={'0.5vw'}>{"Chart Details"}</Typography>
                        <Box sx={{ height: "19.5vw", overflow: "scroll", padding: '0.5vw' }}>
                            <Stack spacing={1}>
                                <TextField
                                    label={"Brand"}
                                    size='small'
                                    fullWidth
                                    inputProps={{ maxLength: 100 }}
                                    variant="outlined"
                                    value={selectedData?.brand || ''}
                                    onChange={(event) => setSelectedData({ ...selectedData, brand: event.target.value })}
                                />
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        open={openDatePicker}
                                        onOpen={() => { setOpenDatePicker(true) }}
                                        onClose={() => { setOpenDatePicker(false) }}
                                        value={selectedData?.given_date || null}
                                        inputFormat='DD-MM-YYYY'
                                        label={'Given Date *'}
                                        minDate={dobDate}
                                        maxDate={new Date()}
                                        onChange={(newDate) => setSelectedData({ ...selectedData, given_date: newDate })}
                                        renderInput={(params) => <TextField {...params} size='small' fullWidth autoComplete="off"
                                        onKeyDown={(e) => e.preventDefault()} onClick={() => { setOpenDatePicker(true) }} />}
                                    />
                                </LocalizationProvider>
                                <TextField
                                    size='small'
                                    fullWidth
                                    label={`Service Name${hasAbha ? " *" : ""}`}
                                    inputProps={{ maxLength: 50 }}
                                    value={selectedData?.serviceName || ''}
                                    onChange={(event) => setSelectedData({ ...selectedData, serviceName: event.target.value })}
                                />
                                <TextField
                                    size='small'
                                    fullWidth
                                    label={`Service Dose No${hasAbha ? " *" : ""}`}
                                    inputProps={{ maxLength: 25 }}
                                    value={selectedData?.serviceDoseNo || ''}
                                    onChange={(event) => setSelectedData({ ...selectedData, serviceDoseNo: event.target.value })}
                                />
                                <TextField
                                    size='small'
                                    fullWidth
                                    label={`Lot No${hasAbha ? " *" : ""}`}
                                    inputProps={{ maxLength: 25 }}
                                    value={selectedData?.lotNo || ''}
                                    onChange={(event) => setSelectedData({ ...selectedData, lotNo: event.target.value })}
                                />
                                <TextField
                                    size='small'
                                    fullWidth
                                    label={`Manufacturer Name${hasAbha ? " *" : ""}`}
                                    inputProps={{ maxLength: 50 }}
                                    value={selectedData?.manufacturerName || ''}
                                    onChange={(event) => setSelectedData({ ...selectedData, manufacturerName: event.target.value })}
                                />
                                <Autocomplete
                                    options={(IP_routeList.length != 0) ? IP_routeList : []}
                                    getOptionLabel={option => typeof (option) === "string" ? option : option.value}
                                    value={selectedData.route}
                                    onChange={(e, newValue) => setSelectedData({ ...selectedData, route: newValue })}
                                    renderInput={(params) => <TextField {...params} label={`Route${hasAbha ? " *" : ""}`} size="small" />}
                                />
                                <TextField
                                    size='small'
                                    fullWidth
                                    multiline
                                    rows={3}
                                    label="Comments"
                                    inputProps={{ maxLength: 250 }}
                                    value={selectedData?.comments || ''}
                                    onChange={(event) => setSelectedData({ ...selectedData, comments: event.target.value })}
                                />
                            </Stack>
                        </Box>
                        <Box component={'div'} height={'2.5vw'} display={'flex'} justifyContent={'center'} alignItems={'center'} backgroundColor={'#F5F8F7'}>
                            <Stack spacing={1} direction="row">
                                <Button size='small' sx={{ textTransform: 'capitalize' }} onClick={() => onClearValue()} variant="outlined">Clear</Button>
                                <Button size='small' sx={{ textTransform: 'capitalize' }} disabled={!selectedData?.id} onClick={() => onAddHandler()} variant="contained">Add</Button>
                                <Button size='small' sx={{ textTransform: 'capitalize' }} disabled={!selectedData?.id} onClick={() => onAddHandler(true)} variant="contained">Complete</Button>
                            </Stack>
                        </Box>
                    </Box>
                </Box>
            )
        } catch (e) {
            errorMessage(e.message)
        }
    };

    return (
        <Box sx={{ backgroundColor: Colors.Background, height: '78vh', p: '0.5vw' }}>
            <Box component={'div'} display={'flex'}>
                <Box component={'div'} className='doc_header_card' mr={'0.5vw'}>
                    <CommonPatientDetails data={patientDetails} showDetailed={true} />
                </Box>
            </Box>
            <Box display="flex" mt="0.5vw">
                <Box component={'div'}>
                    {renderTbl(finalArray)}
                </Box>
                <Box component={'div'}>
                    {renderRightSide(finalArray)}
                </Box>
            </Box>

            {isErrorMsg && (
                <ToastMsg severity="error" msg={isErrorMsgText} msgPop={msgClose} />
            )}

            {successMsg && (
                <ToastMsg severity="success" msg={successMsgText} msgPop={msgClose} />
            )}

            <Loader loaderOpen={isLoader} />
        </Box>
    );
};